import styled from '@emotion/styled';

export const Container = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const FormContainer = styled.div`
    flex: 1;
    padding: ${({ theme }) => theme.spacing[4]};
    width: 100%;
    background: ${({ theme }) => theme.color.white100};
    border: 1px solid ${({ theme }) => theme.color.grey300};
    border-radius: ${({ theme }) => theme.radius.main};

    & > *:not(:last-of-type) {
        margin-bottom: ${({ theme }) => theme.spacing[4]};
    }
`;

export const SpacedFlex = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    & > * {
        flex: 1;
    }
`;

export const ConfirmationBarContainer = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
`;

export const DuplicateNameWarningDescription = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
